import { render, staticRenderFns } from "./index.vue?vue&type=template&id=01280fc9"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01280fc9')) {
      api.createRecord('01280fc9', component.options)
    } else {
      api.reload('01280fc9', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=01280fc9", function () {
      api.rerender('01280fc9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pay/orders/index.vue"
export default component.exports